import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  headerItem: {
    fontWeight: 800,
    fontSize: 11,
    color: colors.neutral900,
    lineHeight: '1.3px',
  },

  headerItems: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    borderBottom: `1px solid ${colors.neutral}`,
    height: 30,
    minHeight: 30,
    width: '100%',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.neutral200}`,
  },

  cell: {
    fontSize: 11,
    marginTop: 12,
    color: colors.neutral700,
    fontWeight: 400,
    height: 30,
    lineHeight: '1.3px',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  headerItemLeft: {
    flex: 2,
    textAlign: 'left',
  },
  headerItemRight: {
    flex: 1,
    textAlign: 'right',
  },

  headerItemCenter: {
    flex: 1,
    textAlign: 'center',
  },
  rowCell: {
    fontSize: 11,
    color: colors.neutral900,
    fontWeight: 400,
    marginTop: 12,
    height: 30,
    lineHeight: '1.3px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.neutral200}`,
  },
});
